export const tr = {
    'condition-type-all': 'Hepsi uygulandı',
    'condition-type-not': 'Hiçbiri uygulanmadı',
    'condition-type-or': 'En az bir uygulandı',
    'day-description': {
        one: '{count} günlük',
        some: '{count} günlük',
        many: '{count} günlük',
        none: ''
    },
    'no-metrika-goal-value': 'Hedef bulunamadı',
    'no-segment-value': 'Segment bulunamadı',
    'status-active': 'Aktif',
    'status-stopped': 'Durduruldu'
};
